import {useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import Card from '../../components/CourseCard/Card'
import { getCourseData } from '../../courseData'
import "./Courses.css"

const Courses = () => {
  interface CoursesProps{
    id?: number,
    name?: string,
    category?: string,
    price?: number,
    image: { Location: string };
    instructor:{name: string}
    
  }
  //adding CoursesProps in generic type causes an error without any
  const [courses, setCourses] = useState<CoursesProps | any>([]);
  
  useEffect(() => { 
    (async () => setCourses(await getCourseData()))();
  }, []);
  const numCourses=courses.length;
  
  return (
    <div className='CoursesContainer'>
      
      <h1 className='Heading'>{ numCourses} Course(s)</h1>
      <div className='ItemDesc'>
        {courses.map((course: { id: number; name: string; description: string; price: number; image: { Location: string }; category: string; instructor:{name: string} }) => {
            
            return (
              <Link to={`/courses/${course.name}`}>
                <Card
                  key={course.id}
                  name={course.name}
                  category={course.category}
                  price={course.price}
                  image={course.image?.Location}
                  instructor= {course.instructor}
                />
              </Link>
            );
          })}
      </div>
      
      
    </div>
  )
}

export default Courses